export default "__VITE_ASSET__DkWrURqh__"